// extracted by mini-css-extract-plugin
export default {"container":"aboutUs_container__lPPvH","info":"aboutUs_info__ZRJRU","header":"aboutUs_header__hKjy3","description":"aboutUs_description__uhnVV"};